// removed by extract-text-webpack-plugin
module.exports = {"Order":"Order__Order__3POXa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/order/Order.css
// module id = 145
// module chunks = 0